import { render, staticRenderFns } from "./CorruptionChallengeTab.vue?vue&type=template&id=23042155&scoped=true&"
import script from "./CorruptionChallengeTab.vue?vue&type=script&lang=js&"
export * from "./CorruptionChallengeTab.vue?vue&type=script&lang=js&"
import style0 from "./CorruptionChallengeTab.vue?vue&type=style&index=0&id=23042155&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23042155",
  null
  
)

export default component.exports